import { ValidatorFn } from '@angular/forms';
import { ConditionPropertyOperator, PropertyFilter } from '@models/index';
import { Observable } from 'rxjs';

export interface FilterCriterion {
  key: string;
  label: string;
  placeholder: string;
  field: string;
  type: FieldType;
  outputDateFormat?: OutputDateFormat;
  filter?: boolean;
  operation: ConditionPropertyOperator;
  options?: FilterDropdownOption[];
  access?: AccessFilterItem[];
  maxLength?: number;
  validators?: ValidatorFn[];
  dateOptions?: DateOptions;
  optionsRequest$?: (search: string) => Observable<FilterDropdownOption[]>;
}

export interface DateOptions {
  minDateField?: string;
  maxDateField?: string;
  dateFormat?: string;
  timeFormat?: string;
}

export interface AccessFilterItem {
  hideFor?: number[];
  showFor?: number[];
  fieldName: string;
}

export enum OutputDateFormat {
  DateOnly = 'dateOnly',
  DateTime = 'dateTime',
}

export enum FieldType {
  Text = 'text',
  Number = 'number',
  Date = 'date',
  Select = 'select',
  MultipleSelect = 'multipleSelect',
  Lookup = 'lookup',
  MultipleLookup = 'multipleLookup',
}

export interface FilterModalData {
  filterCriteria: FilterCriterion[];
  selectedValues?: {
    propertyName?: string;
    key: string;
    values?: string[];
    value?: string;
    entityPropertyFilters?: PropertyFilter[];
  }[];
}

export interface FilterModalResult {
  key: string;
  values: string[];
  operation: ConditionPropertyOperator;
  field?: string;
  type?: string;
}

export interface FilterDropdownOption {
  id: number | null;
  displayName: string;
  value: string;
  key?: string;
}
